<template>
  <div class="container page bc-body sl-lottery">
    <!-- 底部导航 -->
    
    <!-- 顶部 -->
    <div class="bc-top">
      <div class="bc-left">
        <van-icon name="arrow-left" @click="back()" />
        <div class="bc-title">
          <div class="main-title">{{ formatGameName(lottery.name) }}</div>
        </div>
      </div>
      <div class="font" @click="back()">{{ $t("Universal.window") }}</div>
    </div>
    <!-- ====================== 【活动结果 - 永远显示往期第一条】 ====================== -->
    <div class="end legacy-result">
      <div class="end-header">
        <div class="end-info">
          <div class="t1">
            {{ latestResult?.expect || lottery.now_expect || "加载中..." }}
          </div>
          <div class="t2">
            {{ $t("Universal.Activity") }}
          </div>
        </div>
        <div class="countdown-container">
          <!-- <span class="p1">{{ $t("Universal.window") }}</span> -->
          <van-count-down :time="time" @finish="check()" />
        </div>
      </div>
      <div class="box">
        <div class="box1">
          {{ latestResult?.sum || "?" }}
        </div>
        <div class="boxs">
          <div class="box2" style="margin-bottom: 0.4rem">
            {{
              Number(latestResult?.opencode[0]) +
                Number(latestResult?.opencode[1]) +
                Number(latestResult?.opencode[2]) >=
                11 &&
              Number(latestResult?.opencode[0]) +
                Number(latestResult?.opencode[1]) +
                Number(latestResult?.opencode[2]) <=
                18
                ? $t("reservation.big")
                : $t("reservation.small")
            }}
          </div>
          <div class="box2">
            {{
              (Number(latestResult?.opencode[0]) +
                Number(latestResult?.opencode[1]) +
                Number(latestResult?.opencode[2])) %
                2 ===
              0
                ? $t("reservation.single")
                : $t("reservation.double")
            }}
          </div>
        </div>
        <div class="img">
          <img
            src="../../assets/bc-img/list.png"
            alt=""
            @click="$router.push({ path: '/GameRecord' })"
          />
        </div>
      </div>
    </div>
    <!-- ======================================================================= -->
    <div class="record-actions">
      <div class="action-countdown">
        <div class="action-period">
          <span class="action-period-label">期數</span>
          <span class="action-period-number">{{ currentPeriodSuffix }}</span>
        </div>
        <van-count-down :time="time" @finish="check()" />
      </div>
      <button type="button" @click="openLotteryHistory">
        {{ $t("Universal.view_history_records") }}
      </button>
      <button type="button" @click="goOrderRecords">
        {{ $t("Universal.view_order_records") }}
      </button>
    </div>

    <!-- 礼物 -->
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
          <div class="tips">
            <div class="bc-content">
              <!-- <p
                style="
                  color: #e7b58e;
                  font-weight: lighter !important;
                  font-size: 0.7rem;
                "
              >
                {{ $t("Universal.task_order") }}
              </p> -->
              <p class="odds">{{ formatGameName(this.lottery.name) }}</p>
            </div>
          </div>
          <div
            class="linear-gradient"
            style="
              background: linear-gradient(
                to right,
                rgba(126, 86, 120, 0),
                rgb(230, 195, 161),
                rgba(126, 86, 120, 0)
              );
            "
          ></div>
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              :class="{ active: choose[v.type] }"
              v-for="(v, key) in lottery_peilv_list"
              :key="key"
              @click="choosePlay(v.type, v.name)"
            >
              <div class="wrapper">
                <div class="content">
                  <!-- <p class="name-text large">{{ v.name }}</p> -->
                  <p class="name-text large">
                    <span v-if="v.name === '玫瑰'">
                      {{ $t("reservation.big") }}
                    </span>
                    <span v-if="v.name === '百合'">
                      {{ $t("reservation.small") }}
                    </span>
                    <span v-if="v.name === '烟花'">
                      {{ $t("reservation.double") }}
                    </span>
                    <span v-if="v.name === '气球'">
                      {{ $t("reservation.single") }}
                    </span>
                  </p>
                  <p class="odd-text large">
                    <img
                      v-if="v.type === '玫瑰'"
                      src="@/assets/bc-img/meigui.png"
                      class="pic-icon"
                      alt=""
                    />
                    <img
                      v-else-if="v.type === '百合'"
                      src="@/assets/bc-img/baihe.png"
                      class="pic-icon"
                      alt=""
                    />
                    <img
                      v-else-if="v.type === '烟花'"
                      src="@/assets/bc-img/yanhua.png"
                      class="pic-icon"
                      alt=""
                    />
                    <img
                      v-else-if="v.type === '气球'"
                      src="@/assets/bc-img/qiqiu.png"
                      class="pic-icon"
                      alt=""
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar">
        <div class="bar bc-bar">
          <div class="bartext">
            <div
              style="
                display: flex;
                align-items: center;
                font-weight: lighter !important;
              "
            >
              <div class="bctext">{{ $t("reservation.curr_choose") }}</div>
              <div
                class="bet-number bctext"
                style="
                  color: #c56e81;
                  margin-left: 0.5rem;
                  font-weight: bold !important;
                "
              >
                <!-- {{ this.shopchoose }} -->
                <span v-if="shopchoose === $t('reservation.no_choose')">
                  {{ shopchoose }}
                </span>
                <template v-else-if="shopchoose.includes(',')">
                  <span
                    v-for="(item, idx) in shopchoose.split(',')"
                    :key="idx"
                    style="margin-right: 4px"
                  >
                    <span v-if="item.trim() === '玫瑰'">{{
                      $t("reservation.big")
                    }}</span>
                    <span v-else-if="item.trim() === '百合'">{{
                      $t("reservation.small")
                    }}</span>
                    <span v-else-if="item.trim() === '烟花'">{{
                      $t("reservation.double")
                    }}</span>
                    <span v-else-if="item.trim() === '气球'">{{
                      $t("reservation.single")
                    }}</span>
                    <span v-else>{{ item }}</span>
                  </span>
                </template>
                <span v-else>
                  <span v-if="shopchoose === '玫瑰'">{{
                    $t("reservation.big")
                  }}</span>
                  <span v-else-if="shopchoose === '百合'">{{
                    $t("reservation.small")
                  }}</span>
                  <span v-else-if="shopchoose === '烟花'">{{
                    $t("reservation.double")
                  }}</span>
                  <span v-else-if="shopchoose === '气球'">{{
                    $t("reservation.single")
                  }}</span>
                  <span v-else>{{ shopchoose }}</span>
                </span>
              </div>
            </div>
            <div @click="shopping ? (shopping = false) : (shopping = true)">
              <van-icon name="cart-o" class="jixuanico" />
            </div>
          </div>
          <div class="mid">
            <div style="">
              <p class="text bctext">
                {{ $t("reservation.available_balance") }}
              </p>
              <p class="m-flex bc-flex2">
                <span class="text num">{{ this.userInfo.money }}</span>
              </p>
            </div>
            <div class="bc-right" @click="jiesuan()">
              {{ $t("reservation.submit") }}
            </div>
          </div>
        </div>
        <!-- 弹窗 -->
        <div class="wrapper" :class="{ active: shopping }">
          <div class="item">
            <span class="label">{{ $t("reservation.per_price") }}</span>
            <div class="amount-wrapper">
              <van-field
                v-model="money"
                type="digit"
                :placeholder="$t('reservation.price_place')"
              />
              <span class="label">{{ $t("reservation.unit") }}</span>
            </div>
          </div>
          <div class="item">
            <div class="part">
              <span style="color: #fff; font-weight: lighter !important">{{
                $t("reservation.total")
              }}</span>
              <span class="number">{{ this.formData.length }}</span>
            </div>
            <div class="part">
              <span style="color: #fff; font-weight: lighter !important">{{
                $t("reservation.total")
              }}</span>
              <span class="number">{{
                this.formData.length * this.money
              }}</span>
              <span style="color: #fff; font-weight: lighter !important">{{
                $t("reservation.unit")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal sl-detail-dialog">
          <div class="head van-hairline--bottom">
            <p class="text">{{ $t("reservation.task_list") }}</p>
          </div>
          <ui class="list">
            <li
              v-for="(v, key) in formData"
              :key="key"
              class="lise-item van-hairline--bottom"
            >
              <div class="main">
                <p class="bet-name">
                  <!-- 根据 v.name 自动切换翻译文本 -->
                  <span v-if="v.name === '玫瑰'">{{
                    $t("reservation.big")
                  }}</span>
                  <span v-else-if="v.name === '百合'">{{
                    $t("reservation.small")
                  }}</span>
                  <span v-else-if="v.name === '烟花'">{{
                    $t("reservation.double")
                  }}</span>
                  <span v-else-if="v.name === '气球'">{{
                    $t("reservation.single")
                  }}</span>
                  <span v-else>{{ v.name }}</span>
                </p>
                <p class="detail-text">
                  1{{ $t("reservation.note") }} X {{ money
                  }}{{ $t("reservation.unit") }} = {{ money
                  }}{{ $t("reservation.unit") }}
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="sub-bar">
            <van-button
              class="item cancel-btn"
              type="default"
              @click="allClear()"
              >{{ $t("reservation.clear_order") }}</van-button
            >
            <van-button class="item sub-btn" type="default" @click="doSub">{{
              $t("reservation.submit")
            }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup class="sl-detail-history" v-model="active" get-container="body" position="top" :style="{ height: '70%' }">
        <van-pull-refresh
          :pulling-text="$t('Universal.Refresh')"
          :loosing-text="$t('Universal.Reorganize')"
          :loading-text="$t('Universal.Refresh')"
          :success-text="$t('Universal.Refresh')"
          v-model="isLoading"
          @refresh="onRefresh"
        >
          <div class="wrapper">
            <div class="item">
              <div class="left font-weight">{{ $t("reservation.num") }}</div>
              <div class="right font-weight">
                {{ $t("reservation.win_num") }}
              </div>
            </div>
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
                  <span class="res-des middle">{{
                    v.opencode[0] - 0 + v.opencode[1] - 0 + v.opencode[2] - 0 >=
                      11 &&
                    v.opencode[0] - 0 + v.opencode[1] - 0 + v.opencode[2] - 0 <=
                      18
                      ? $t("reservation.big")
                      : $t("reservation.small")
                  }}</span>
                  <span class="res-des middle">{{
                    (v.opencode[0] -
                      0 +
                      v.opencode[1] -
                      0 +
                      v.opencode[2] -
                      0) %
                      2 ===
                    0
                      ? $t("reservation.single")
                      : $t("reservation.double")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>

      <!-- 中奖弹窗 -->
      <div class="alert">
        <van-popup v-model="winPopup" position="center" get-container="body">
          <div class="bc-alert">
            <h2>{{ $t("Universal.win") }}</h2>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "../../common/Footer.vue";
var time;
var count = 0;

// 用来标记是否已经判断过中奖，避免重复弹
let hasCheckWin = false;

export default {
  name: 'Lottery',
  components: {
    Footer,
  },
  data() {
    return {
      money_show: true,
      jiesuanpage: false,
      choose: {},
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      list: [],
      latestResult: null,
      winPopup: false,
      isPageActive: false,
      isRedirecting: false,
      lastHandledExpect: "",
      preserveToastOnLeave: false,
    };
  },
  computed: {
    currentPeriodSuffix() {
      const expect =
        this.lottery.now_expect ||
        this.lottery.next_expect ||
        (this.latestResult && this.latestResult.expect) ||
        "";
      const text = String(expect || "");
      return text ? text.slice(-4) : "----";
    },
  },
  methods: {
    formatGameName(name) {
      return String(name || "").replace(/投注入口/g, "遊戲入口");
    },
    openLotteryHistory() {
      this.active = true;
      if (!Array.isArray(this.lottery_list) || this.lottery_list.length === 0) {
        this.getLotteryOneList();
      }
    },
    goOrderRecords() {
      this.$router.push({ path: "/GameRecord" });
    },
    getLotteryCacheKey() {
      return `lottery_page_cache_${this.$route.query.key || "default"}_${
        this.$route.query.id || "default"
      }`;
    },
    applyCachedLotteryData() {
      const storeUserInfo = this.$store.getters.getUserInfo;
      if (storeUserInfo && Object.keys(storeUserInfo).length > 0) {
        this.userInfo = { ...storeUserInfo };
      } else {
        const localUserInfo = localStorage.getItem("cached_user_info");
        if (localUserInfo) {
          try {
            const parsedUserInfo = JSON.parse(localUserInfo);
            if (parsedUserInfo && Object.keys(parsedUserInfo).length > 0) {
              this.userInfo = parsedUserInfo;
            }
          } catch (error) {}
        }
      }

      const cache = localStorage.getItem(this.getLotteryCacheKey());
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.lottery = parsed.lottery || this.lottery;
        this.time = parsed.time || this.time;
        this.latestResult = parsed.latestResult || this.latestResult;
        this.lottery_list = Array.isArray(parsed.lottery_list)
          ? parsed.lottery_list
          : this.lottery_list;
        this.lottery_peilv_list = Array.isArray(parsed.lottery_peilv_list)
          ? parsed.lottery_peilv_list
          : this.lottery_peilv_list;
        this.lastHandledExpect = parsed.lastHandledExpect || this.lastHandledExpect;
        this.lottery_peilv_list.forEach((item) => {
          if (item && item.type) {
            this.$set(this.choose, item.type, false);
          }
        });
        return true;
      } catch (error) {
        return false;
      }
    },
    persistLotteryData() {
      localStorage.setItem(
        this.getLotteryCacheKey(),
        JSON.stringify({
          lottery: this.lottery,
          time: this.time,
          latestResult: this.latestResult,
          lottery_list: this.lottery_list,
          lottery_peilv_list: this.lottery_peilv_list,
          lastHandledExpect: this.lastHandledExpect,
        })
      );
    },
    cleanupPageState() {
      this.isPageActive = false;
      this.isRedirecting = false;
      this.winPopup = false;
      clearInterval(time);
      count = 0;
      hasCheckWin = false;
      if (
        !this.preserveToastOnLeave &&
        this.$toast &&
        typeof this.$toast.clear === "function"
      ) {
        this.$toast.clear();
      }
      this.preserveToastOnLeave = false;
    },
    handleRestrictedAccess() {
      if (!this.isPageActive || this.isRedirecting || this.$route.name !== "Lottery") {
        return false;
      }
      this.isRedirecting = true;
      this.preserveToastOnLeave = false;
      clearInterval(time);
      count = 0;
      if (this.$toast && typeof this.$toast.clear === "function") {
        this.$toast.clear();
      }
      this.$router.replace({
        path: "/Home",
        query: {
          redirect_tip: "contact_admin",
          redirect_ts: String(Date.now()),
        },
      });
      return false;
    },
    checkLotteryAccess(condition) {
      if (!this.isPageActive) {
        return false;
      }
      const money = parseFloat(this.userInfo.money || 0);
      const limit = parseFloat(condition || 0);
      const hasPending = Array.isArray(this.list)
        ? this.list.some((item) => Number(item.status) === 0)
        : false;
      if (money < 0) {
        return this.handleRestrictedAccess();
      }
      if (money < limit && !hasPending) {
        return this.handleRestrictedAccess();
      }
      return true;
    },
    async getUserGameSnapshot() {
      const res = await this.$http({
        method: "get",
        url: "user_get_game_list",
      });
      if (!this.isPageActive) {
        return res;
      }
      if (res.code === 200) {
        this.list = Array.isArray(res.data) ? res.data : [];
      }
      return res;
    },
    async initLotteryPage() {
      await Promise.all([this.getUserInfo(), this.getUserGameSnapshot()]);
      const canEnter = await this.getLotteryInfo();
      if (canEnter === false) return;
      await Promise.all([this.getLotteryList(), this.getLotteryPeilv()]);
    },
    getLotteryList() {
      return this.$http({
        method: "get",
        data: { key: this.$route.query.key },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (!this.isPageActive) {
          return res;
        }
        if (res.code === 200) {
          this.lottery_list = res.data;
          if (res.data && res.data.length > 0) {
            let first = res.data[0];
            const previousExpect = this.lastHandledExpect;
            const currentExpect = String(first.expect || "");

            let sum =
              Number(first.opencode[0]) +
              Number(first.opencode[1]) +
              Number(first.opencode[2]);
            this.latestResult = {
              ...first,
              sum: sum,
            };
            if (currentExpect && currentExpect !== previousExpect) {
              this.lastHandledExpect = currentExpect;
              this.afterLatestResultUpdated();
            }
          }
          this.persistLotteryData();
        }
        return res;
      });
    },

    // 每次 latestResult 更新后，自动判断中奖
    afterLatestResultUpdated() {
      if (!this.latestResult) return;
      Promise.all([this.getUserGameSnapshot(), this.getUserInfo()]).then(() => {
        if (!this.isPageActive) {
          return;
        }
        if (this.lottery && this.checkLotteryAccess(this.lottery.condition) === false) {
          return;
        }
        if (hasCheckWin) return; // 已经弹过就不再弹
        if (
          this.list.length > 0 &&
          String(this.list[0].expect) === String(this.latestResult.expect) &&
          this.list[0].is_win === 1
        ) {
          hasCheckWin = true;
          setTimeout(() => {
            if (this.isPageActive) {
              this.winPopup = true;
            }
          }, 200);
        }
      });
    },

    getUserGameList() {
      // 逻辑移到 afterLatestResultUpdated，统一管理
    },

    back() {
      this.$router.push("/game");
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan() {
      return this.doSub();
    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        let str = "";
        let itemStr = "";
        this.formData.forEach((item, index) => {
          if (index === 0) {
            str = item.name;
            itemStr = item.type;
          } else {
            str += "," + item.name;
            itemStr += "," + item.type;
          }
        });
        this.shopchoose = str;
        this.gameitem = itemStr;
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        this.formData = this.formData.filter((item) => item.type !== type);
      } else {
        this.formData.push({ name, type });
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        let str = "";
        let itemStr = "";
        this.formData.forEach((item, index) => {
          if (index === 0) {
            str = item.name;
            itemStr = item.type;
          } else {
            str += "," + item.name;
            itemStr += "," + item.type;
          }
        });
        this.shopchoose = str;
        this.gameitem = itemStr;
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },

    check() {
      if (!this.isPageActive) {
        return;
      }
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }

      // 重置中奖检测，允许新一轮判断
      hasCheckWin = false;
      clearInterval(time);
      count = 0;

      // 开始轮询刷新接口，直到拿到最新期号
      time = setInterval(() => {
        if (!this.isPageActive) {
          clearInterval(time);
          count = 0;
          return;
        }
        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList(); // 🔥 每次刷新都会自动判断中奖
        count++;
        if (count > 6) {
          clearInterval(time);
          count = 0;
        }
      }, 1000);
    },

    onRefresh() {
      Promise.all([this.getLotteryInfo(), this.getLotteryList(), this.getLotteryPeilv()]).finally(() => {
        this.isLoading = false;
      });
    },
    getUserInfo() {
      return this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (!this.isPageActive) {
          return res;
        }
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("setUserInfoValue", res.data);
          localStorage.setItem("cached_user_info", JSON.stringify(res.data));
        }
        return res;
      });
    },
    getLotteryPeilv() {
      return this.$http({
        method: "post",
        data: { id: this.$route.query.id },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (!this.isPageActive) {
          return res;
        }
        if (res.code === 200) {
          this.lottery_peilv_list = Array.isArray(res.data) ? res.data : [];
          this.lottery_peilv_list.forEach((item) => {
            this.$set(this.choose, item.type, false);
          });
          this.persistLotteryData();
        }
        return res;
      });
    },
    getLotteryInfo() {
      return this.$http({
        method: "get",
        data: { key: this.$route.query.key },
        url: "lottery_get_info",
      }).then((res) => {
        if (!this.isPageActive) {
          return res;
        }
        if (res.code === 200) {
          if (this.checkLotteryAccess(res.data.condition) === false) {
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;
          this.persistLotteryData();
        }
        return res;
      });
    },
  },
  created() {
    hasCheckWin = false;
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.isPageActive = true;
      this.isRedirecting = false;
      this.preserveToastOnLeave = false;
      this.winPopup = false;
      this.applyCachedLotteryData();
      this.initLotteryPage();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.cleanupPageState();
    next();
  },
  destroyed() {
    this.cleanupPageState();
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";

// 自定义颜色变量，更柔和的配色
@primary-orange: #F8A345;
@primary-yellow: #F5D387;
@primary-black: #000000;
@primary-dark: #1A1A1A;
@text-color: #E8D4B5;

.van-popup {
  background: none !important;
}
.bc-alert {
  width: 500px;
  height: 300px;
  background: url(../../assets/bc-img/alert.png),
    linear-gradient(to bottom right, @primary-orange, @primary-yellow);
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 1rem !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 4rem !important;

  h2 {
    color: @primary-black;
    font-size: 2rem;
    // margin-bottom: 20px;
  }
}

.van-icon {
  color: @text-color;
}
.bc-right {
  background: linear-gradient(to right, @primary-orange, @primary-yellow);
  padding: 0.3rem 1.5rem;
  border-radius: 0.5rem;
  color: @primary-black;
  font-weight: bold;
}
.bctext {
  font-size: 0.7rem;
  font-weight: lighter !important;
  color: @text-color;
}
.bc-flex2 {
  font-size: 1rem !important;
}
.m-flex {
  margin: 0 !important;
}
.bc-bar {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-start;
  .bartext {
    display: flex;
    width: 100%;
    color: @text-color;
    justify-content: space-between;
    .bet-info {
      display: flex;
      align-items: center;
      font-weight: lighter !important;
    }
    .bet-number {
      color: @primary-orange;
      margin-left: 0.5rem;
      font-weight: bold !important;
    }
  }
  .mid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .balance-info {
      display: flex;
      flex-direction: column;
    }
  }
}
.bc-content {
  height: 3vh;
  p {
    margin: 0 !important;
  }
}
.end {
  width: auto;
  height: auto;
  padding: 0.5rem 0.5rem;
  background: linear-gradient(to right, @primary-dark, @primary-black);
  border: 1px solid @primary-orange;
  margin: 0 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .end-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 0.5rem;
    .end-info {
      display: flex;
      flex-direction: column;
    }
    .countdown-container {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .p1 {
        color: @text-color;
        font-weight: lighter !important;
        font-size: 0.6rem;
      }
    }
  }
  .t1 {
    color: @text-color;
    font-weight: lighter !important;
    font-size: 0.7rem;
  }
  .t2 {
    color: @text-color;
    font-size: 0.9rem;
  }
  .box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    .box1 {
      color: @primary-black;
      font-size: 1.3rem;
      // padding: 0.4rem 0.6rem;
      width: 3rem;
      height: 3rem;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: linear-gradient(to right bottom, @primary-orange, @primary-yellow);
    }
    .boxs {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 0.5rem;
      .box2 {
        background: linear-gradient(to right bottom, @primary-orange, @primary-yellow);
        width: auto;
        color: @primary-black;
        font-weight: bold !important;
        font-size: 0.7rem;
        border-radius: 2rem;
        height: 3vh;
        width: 70vw;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    img {
      width: 1rem;
      height: 1.3rem;
    }
  }
}
.legacy-result {
  display: none;
}
.record-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem;
  margin: 0.7rem 1rem 0.4rem;
}
.action-countdown {
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 2rem;
  border: 1px solid @primary-orange;
  border-radius: 0.7rem;
  background: rgba(26, 26, 26, 0.78);
  box-sizing: border-box;
  padding: 0 0.85rem;
}
.action-period {
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: 0.28rem;
  color: @primary-yellow;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1;
}
.action-period-label {
  color: @text-color;
  font-size: 0.62rem;
  font-weight: 600;
}
.action-period-number {
  white-space: nowrap;
}
.action-countdown ::v-deep .van-count-down {
  flex: 0 0 auto;
  color: @primary-yellow !important;
  font-size: 1rem;
  font-weight: 700;
}
.record-actions button {
  min-height: 2.3rem;
  border: 1px solid @primary-orange;
  border-radius: 0.7rem;
  background: linear-gradient(135deg, @primary-orange, @primary-yellow);
  color: @primary-black;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.25;
  padding: 0.35rem 0.45rem;
  box-shadow: 0 0.45rem 1rem rgba(0, 0, 0, 0.24);
}
.bc-number {
  width: 69%;
  background-color: @primary-dark;
  border: 1px solid @primary-orange;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.4rem 1rem 0.5rem 0.5rem;
  .p1 {
    color: @primary-yellow;
    font-weight: lighter !important;
    font-size: 0.6rem;
  }
}
.bc-body {
  padding-bottom: 5.2rem;
  background: linear-gradient(#1A1A1A,#000);
}
.font {
  color: @primary-black;
  weight: lighter !important;
  font-size: 0.6rem;
  background: linear-gradient(to right, @primary-orange, @primary-yellow);
  padding: 0.2rem 0.6rem;
  border-radius: 2rem;
  border: 1px solid @primary-yellow;
  width: auto;
  font-weight: bold;
}
.bc-top {
  width: 100%;
  height: auto;
  background: linear-gradient(to right, @primary-dark, @primary-black);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.6rem !important;
  // border-bottom: 1px solid @primary-orange;
  .bc-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .bc-title {
    display: flex;
    flex-direction: column;
    padding-left: 0.5rem;
    .subtitle {
      color: @text-color;
      font-weight: lighter !important;
      font-size: 0.7rem;
    }
    .main-title {
      color: @text-color;
      font-size: 1.2rem;
    }
  }
  .font {
    color: #000;
  }
}
.record {
  margin: @md1;
  z-index: 1;
  border-radius: 1em 1em 0 0;
}
.record .period {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.record .period .period-number {
  flex: 1;
  margin-right: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 35px;
  font-weight: 700;
  color: @primary-yellow;
}
.van-count-down {
  color: @primary-yellow !important;
  font-size: 38px;
  margin-top: 10px;
}
// .linear-gradient {
//   width: 100%;
//   height: 2px;
//   background: linear-gradient(
//     to right,
//     rgba(255, 154, 0, 0),
//     @primary-yellow,
//     rgba(255, 154, 0, 0)
//   );
// }
.kuaisan-ball .left {
  justify-content: flex-start;
}
.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
  color: @primary-yellow;
}
.kuaisan-ball .res-des {
  flex: 1;
  font-weight: 700;
  text-align: center;
  color: @primary-yellow;
}
.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}
.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
  min-height: 0;
}
.options-bar {
  display: flex;
  align-items: flex-start;
  height: calc(100% - 210px);
  min-height: 0;
}
.options-bar .game {
  flex: 1;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 30px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips {
  display: flex;
  align-items: center !important;
  justify-content: space-between;
  height: 100px;
  padding: 0 20px;
}
.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  color: @primary-yellow;
}
.sumValueTwoSides {
  display: flex;
  padding: 0 @pd1;
  flex-direction: row;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.rectangle {
  overflow: hidden;
}
.rectangle.large {
  margin: 0.5em 0;
  width: 48%;
  border-radius: 10px;
}
.rectangle .wrapper {
  position: relative;
  padding: 0 10px;
  background: rgba(26, 26, 26, 0.7);
  border: 1px solid @primary-orange;
  backdrop-filter: blur(5px);
}
.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.rectangle.large .wrapper {
  padding-bottom: 50%;
}
.rectangle .wrapper .content .name-text.large {
  font-size: 4vw;
}
.rectangle .wrapper .content .name-text {
  color: @text-color;
  font-weight: bolder;
}
.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
}
.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: @text-color;
}
.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 150px;
  z-index: 2;
  pointer-events: none;
}
.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background-color: @primary-dark;
  z-index: 2;
  padding: 0.5rem 1em 1.5rem 1rem;
  border-radius: 1rem;
  border: 1px solid @primary-orange;
  pointer-events: auto;
}
.bottom-bar .bar .mid {
  flex: 1;
  margin: 0;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.bottom-bar .bar .mid .text {
  color: @primary-yellow;
  margin: 0 !important;
}
.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: @primary-yellow;
  font-weight: bold;
}
.jixuanico {
  font-size: 40px;
  color: @primary-yellow !important;
}
.rectangle.active .wrapper {
  background: linear-gradient(to right bottom, @primary-orange, @primary-yellow) !important;
  border-color: @primary-yellow;
}
.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: @primary-black !important;
  font-weight: bold;
}
.bottom-bar .wrapper {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 180px;
  background-color: @primary-dark;
  z-index: 1;
  border-top: 1px solid @primary-orange;
  transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.55, 1.01);
  pointer-events: auto;
  /deep/ .van-field {
    margin: 0 0.5em;
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid @primary-orange;
    border-radius: @br1;
  }
}
.bottom-bar .wrapper.active {
  transform: translateY(-100%);
}
.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
  border: none;
}
.bottom-bar .wrapper .item .label {
  font-size: 25px;
  line-height: 30px;
  font-weight: lighter !important;
  color: @text-color;
}
.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .wrapper .item .part {
  margin-right: 20px;
}
.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: @text-color;
}
.bottom-bar .wrapper .item .part .number {
  margin: 0 5px;
  color: @text-color;
  font-weight: bold;
}
::v-deep .van-field__control {
  color: @text-color;
  font-size: 0.8rem;
}
.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: @primary-dark;
  border-radius: 30px;
  border: 1px solid @primary-orange;
}
.confirm-order-modal .head {
  position: relative;
  height: 80px;
}
.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: @text-color;
}
.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid @primary-orange;
}
.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name {
  color: @text-color;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
}
.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: @text-color;
}
.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid @primary-orange;
  color: @text-color;
  background-color: @primary-dark;
}
.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(270deg, @primary-orange, @primary-yellow);
  color: @primary-black;
  border: 0;
  font-weight: bold;
}
.next-number {
  font-size: 35px;
  font-weight: 700;
  color: @primary-yellow;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 30%;
  background-color: @primary-dark;
  border: 1px solid @primary-orange;
  padding: 1.6rem 1rem 1rem 1rem;
  border-radius: 1rem;
  .p1 {
    color: @primary-yellow;
    font-weight: lighter !important;
    font-size: 0.6rem;
  }
}
.pic-icon {
  width: 40px !important;
  height: 40px !important;
  object-fit: contain !important;
  opacity: 1 !important;
  display: inline-block !important;
  vertical-align: middle;
}
</style>
